import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { Observable } from "rxjs/Observable";
import { TranslationService } from "../../../_services/translation.service";
import { ITranslations } from "../../../_models/ITranslations";
import { DiscountMethod } from "../discount-models/DiscountMethod";
import { FormGroup } from "@angular/forms";
import { GenericFormComponent } from "../../../form/generic-form/generic-form.component";
import { DiscountManagementService } from "../../../_services/discount-management.service";
import {
  discountPaymentOptions,
  newDiscountFormQuestionsContent,
} from "../new-discount-form-select-price/new-discount-form-questions/new-discount-form-questions";
import { EditDiscountFormState } from "../discount-models/EditDiscountFormState";
import { SpecialTypeEventsService } from "../../../_services/eventsServices/specialTypeEvents.service";
import { ChangeEvent } from "ngx-virtual-scroller";
import { take } from "rxjs/operators";

@Component({
  selector: "edit-discount-form-select-price",
  templateUrl: "./edit-discount-form-select-price.component.html",
  styleUrls: [
    "../../events-screen/create-parent-event-form-pricing-row/create-parent-event-form-pricing-row.component.scss",
    "../new-discount-form-select-event-parent/new-discount-form-select-event-parent.component.scss",
    "./edit-discount-form-select-price.component.scss",
  ],
})
export class EditDiscountFormSelectPriceComponent implements OnInit, OnDestroy {
  @Input("newDiscountFormState")
  public editDiscountFormState$: Observable<EditDiscountFormState>;
  @Output("updateDiscountEvent")
  public updateDiscountEvent: EventEmitter<EditDiscountFormState> = new EventEmitter<EditDiscountFormState>();
  public translations$: Observable<ITranslations>;
  public readonly DiscountMethod = DiscountMethod;
  public discountMethod: DiscountMethod = DiscountMethod.Number;
  public formQuestions = newDiscountFormQuestionsContent;
  public additionalDiscountDetailsForm: FormGroup | null;
  public shekelDiscount: any = null;
  public percentDiscount: any = null;
  public originalDiscountAmount: number;
  private currentFormState: EditDiscountFormState;

  constructor(
    protected translationService: TranslationService,
    private discountManagementService: DiscountManagementService
  ) {
    this.translations$ = this.translationService.translations;
  }

  public ngOnInit(): void {
    this.editDiscountFormState$.pipe(take(1)).subscribe((state) => {
      this.shekelDiscount = state.amount.value;
      this.originalDiscountAmount = state.amount.value;
      this.buildAndInitForm(state);
    });
    this.editDiscountFormState$.subscribe((state) => {
      this.currentFormState = state;
    });
  }

  public calculateDiscountHeight() {
    if (this.discountMethod === DiscountMethod.Number) {
      return this.shekelDiscount;
    }
    return this.percentDiscount
      ? this.discountManagementService.calculateInShekelsDiscountedBasedOnPercent(
          this.currentFormState.childDiscountDescription.originalPrice,
          this.percentDiscount
        )
      : 0;
  }

  public calculatePriceAfterDiscount(price: number) {
    return this.discountManagementService.calculatePriceAfterDiscountFromFormPage(
      price,
      this.discountMethod,
      this.shekelDiscount,
      this.percentDiscount
    );
  }

  public ngOnDestroy(): void {}

  public clickedPaymentMethod($event: MouseEvent) {
    if ($event) {
      $event.preventDefault();
    }
    this.discountMethod =
      this.discountMethod === DiscountMethod.Number
        ? DiscountMethod.Percentage
        : DiscountMethod.Number;
    this.emitChange();
  }

  public discountInputChange($event: ChangeEvent) {
    this.emitChange();
  }

  public emitChange() {
    this.updateDiscountEvent.emit({
      ...this.currentFormState,
      amount: {
        type: this.discountMethod,
        value:
          this.discountMethod === DiscountMethod.Number
            ? this.shekelDiscount
            : this.percentDiscount,
      },
    });
  }

  public discountInputBlurEvent($event: FocusEvent) {
    if ($event) {
      $event.preventDefault();
    }
    this.emitChange();
  }

  private buildAndInitForm(state: EditDiscountFormState) {
    const numberOfPayments = state.discountDetails.numberOfPayments;
    const paymentOption =
      discountPaymentOptions.find(
        (p) => p.customValue.toString() === numberOfPayments.toString()
      ) || discountPaymentOptions[0];

    const formQuestions = SpecialTypeEventsService.deepCopyFormQuestions(
      this.formQuestions
    );
    formQuestions.forEach((q) => {
      if (q.fieldName === "numberOfPayments") {
        q.value = paymentOption;
        q.selectedOption = paymentOption;
      } else if (q.fieldName === "passedCommittee") {
        q.value = state.discountDetails.passedCommittee;
      } else if (q.fieldName === "comments") {
        q.value = state.discountDetails.comments;
      }
    });
    this.additionalDiscountDetailsForm =
      GenericFormComponent.buildFormGroup(formQuestions);
    this.additionalDiscountDetailsForm.valueChanges.subscribe((form) => {
      this.updateDiscountEvent.emit({
        ...this.currentFormState,
        discountDetails: {
          numberOfPayments: form.numberOfPayments.customValue,
          passedCommittee: form.passedCommittee,
          comments: form.comments,
        },
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/discounts/edit-discount-form-select-price/edit-discount-form-select-price.component.ts